import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Shoes",
  "description": "",
  "published": "2012-01-16T00:00:00.000Z",
  "redirect_from": ["/blog/shoes/swizec/3466"],
  "categories": "Athletic shoe, Clothing, Footwear, Hiking boot, Shoe, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Shoes are wonderful technology, they protect our feet, they make us look good and there's a whole culture associated with wearing those things. A culture I, as a man, will `}<em parentName="p">{`never`}</em>{` understand.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/01/5764ba26406311e180c9123138016265_74.jpg",
        "alt": "Shoes on their deathbed",
        "title": "Shoes on their deathbed"
      }}></img></p>
    <p>{`Apparently there is a million and one way to wear the wrong kind of shoes to the wrong kind of outfit. For instance, my scruffy shoes ... don't go with any outfit. Or so I've been told. I like to think they go with every outfit exactly `}<em parentName="p">{`because`}</em>{` they're scruffy and falling apart. Gives them a bit of character.`}</p>
    <p>{`But, they are about to die, so I have to find a replacement this week. The thing I don't understand is: Why do women need so many? A good pair of black leather sneakers covers pretty much every occasion.`}</p>
    <ol>
      <li parentName="ol">{`They're comfy, so you can use them for walking to places`}</li>
      <li parentName="ol">{`Because they're black leather, they look nice when clean and can be used for business`}</li>
      <li parentName="ol">{`Because they look kinda nice, they can be used for `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/Semi-formal",
          "title": "Semi-formal"
        }}>{`semi-formal`}</a>{` stuff too. Anything that isn't black- or white- tie really.`}</li>
      <li parentName="ol">{`If you aren't a sissy most sport can be done in them as well`}</li>
    </ol>
    <p>{`The only other pair of shoes you might need is a pair of `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Sandal",
        "title": "Sandal"
      }}>{`sandals`}</a>{`, if you're too sissy to go barefoot at the beach in the summer. And while some advocate using a pair of `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Waterproofing",
        "title": "Waterproofing"
      }}>{`water-proof`}</a>{` shoes for special weather, you don't actually need that. Shoes dry out over night and pretty much all types of shoe I've seen gets soaking wet the moment you start thinking of them as being water-proof.`}</p>
    <p><a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Wellington_boot",
        "title": "Wellington boot"
      }}>{`Rubber boots`}</a>{` old people use for gardening might be an exception, but those get soaking wet from the inside anyway, so what's the point?`}</p>
    <p>{`Last night I asked an internet about the need for multiple shoes and got a rather interesting answer from some girl:`}</p>
    <blockquote>
      <p parentName="blockquote">{`For me I think I have`}</p>
      <p parentName="blockquote">{`3 pairs of heeled sandals (to wear with skirts, dresses, or summer clothes) 2 pairs of flip flops 4 pairs of black boots 1 pair of grey boots (for when black doesn't work with what I'm wearing) 2 pairs of black heels (for dress or black dress pants, ones more business then the other) 2 pairs of black low heeled shoes (business or going somewhere that might include walking) 1 pair of tennis shoes 1 pair of pink heels 1 pair of cobalt blue heels 1 pair of teal heels 2 pairs of low heeled dance shoes 2 pair of latin heeled dance shoes 1 pair of jazz 1 pair of highland 1 pair of low heeled sandals`}</p>
      <p parentName="blockquote">{`Those are the ones I can think of off hand.`}</p>
    </blockquote>
    <p>{`That's just too many shoes! Where does she even keep them all? And who has time to buy all those things anyway? And the mental energy it takes to go out and look for shoes ... women are truly insane.`}</p>
    <p>{`An answer from the most well-dressed guy I know was far better in my view:`}</p>
    <blockquote>
      <p parentName="blockquote">{`In general, men don't need too many shoes short of shoes needed for hobbies. I have two pairs of black shoes, two pairs of brown shoes, and a pair of evening shoes; the rest are activity-specific. Riding boots, hiking boots, dance shoes, boat shoes, cold/wet-climate hiking boots, and so on are only necessary for specific purposes.`}</p>
    </blockquote>
    <p>{`That makes sense, having shoes for specific purposes doesn't really count as having another pair of shoes does it? I certainly wouldn't think of listing my diving fins or rollerblades under "pairs of shoes" even though they are technically footwear ...`}</p>
    <p>{`Now excuse me while I go meditate on my misery of having to buy a new pair of shoes this week.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.fabsugar.com/Shop-Leopard-Print-Shoes-19318554"
        }}>{`Fierce Obsession -15 Pairs of Irresistible Leopard-Print Shoes`}</a>{` (fabsugar.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.savingsjunction.com/the-2011-autumn-guide-to-good-value-and-in-style-shoes/"
        }}>{`The 2011 Autumn Guide to Good Value and In Style Shoes`}</a>{` (savingsjunction.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.savings.com/blog/post/Wardrobe-Oxygen-Fall-Fashion-Footwear-Trends-Splurge-or-Save.html"
        }}>{`Wardrobe Oxygen: Fall Fashion Footwear Trends - Splurge or Save?`}</a>{` (savings.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.fabsugar.com/Shoe-Buying-Tips-8512313"
        }}>{`If the Shoe Fits`}</a>{` (fabsugar.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://anexerciseindiscipline.wordpress.com/2011/12/10/look-they-got-toes/"
        }}>{`Look! They Got Toes!`}</a>{` (anexerciseindiscipline.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://autumnsunshineandgabrielleangel.wordpress.com/2011/10/01/shoes-in-my-closet-by-gabrielle-angel/"
        }}>{`Shoes in my Closet...~By Gabrielle Angel`}</a>{` (autumnsunshineandgabrielleangel.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://ask.metafilter.com/205313/Which-Shoes-Were-Made-For-Walking"
        }}>{`Which Shoes Were Made For Walking?`}</a>{` (ask.metafilter.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://fortyoneplease.wordpress.com/2012/01/15/giuseppe-zanotti-no-heel-crystal-studded-sandal/"
        }}>{`Giuseppe Zanotti No Heel Crystal-Studded Sandal`}</a>{` (fortyoneplease.wordpress.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=8f0ffbb0-31f3-4acd-957e-2aba17284718",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      